import { render, staticRenderFns } from "./usedTable.vue?vue&type=template&id=0af85afc&"
import script from "./usedTable.vue?vue&type=script&lang=js&"
export * from "./usedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports